module.exports = __webpack_public_path__ + "static/media/no-probate.88339488.svg";